import { connect } from 'react-redux';
import {
  getCategoryList,
  getRatingsCount,
  getRatingsScore,
  getRatingsScoreDescription,
  isRating,
} from 'src/store/hotelRating/selectors';
import { getIsMobile } from 'src/store/view/selectors';
import { HotelRating } from './HotelRating';

const mapStateToProps = (state) => ({
  hasRating: isRating(state),
  categoryList: getCategoryList(state),
  score: getRatingsScore(state),
  count: getRatingsCount(state),
  isMobile: getIsMobile(state),
  text: getRatingsScoreDescription(state),
});

export default connect(mapStateToProps)(HotelRating);
